import { createNextTableContext } from '@shared/modules/next-table/context/context'

export const WarehousesTableContext = createNextTableContext()
